// extracted by mini-css-extract-plugin
export default {"component":"TrackerUSP__component-xNTP","listItem":"TrackerUSP__listItem-MQj1","wrapper":"TrackerUSP__wrapper-bose","title":"TrackerUSP__title-qzHc","text":"TrackerUSP__text-xNBt"};